var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: _vm.cols, sm: _vm.sm, md: _vm.md } },
    [
      _c("v-text-field", {
        directives: [
          {
            name: "mask-decimal",
            rawName: "v-mask-decimal.br",
            value: _vm.decmal,
            expression: "decmal",
            modifiers: { br: true },
          },
        ],
        attrs: {
          label: _vm.label,
          "append-icon": _vm.appendIcon,
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          outlined: _vm.outlined,
          hint: _vm.hint,
          "hide-details": _vm.hideDetails,
          "background-color":
            _vm.outlined && _vm.disabled ? `grey lighten-2` : undefined,
          error: _vm.error,
          "error-messages": _vm.errorMessages,
        },
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }